var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("平台管理")]),
            _c("el-breadcrumb-item", [_vm._v("客服管理")]),
            _c("el-breadcrumb-item", { attrs: { to: { name: "orderList" } } }, [
              _vm._v("订单列表"),
            ]),
            _c("el-breadcrumb-item", [_vm._v("订单详情")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "hx-form-container" }, [
      _c(
        "div",
        { staticClass: "hx-table-result" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orderTableLoading,
                  expression: "orderTableLoading",
                },
              ],
              attrs: {
                "show-summary": "",
                "summary-method": _vm.getSummaries,
                data: _vm.orderTableData,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productTitle",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productPrice",
                  label: "商品价格",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                scope.row.productPrice,
                                "元"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productSpec",
                  label: "商品规格",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productQuantity",
                  label: "商品数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "totalAmount",
                  label: "商品总价",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                scope.row.totalAmount,
                                "元"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "amount", label: "结算金额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(scope.row.amount, "元")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }